import { render } from "./OrderBonusSelectionForm.vue?vue&type=template&id=7c8a4a4c&ts=true"
import script from "./OrderBonusSelectionForm.vue?vue&type=script&lang=ts"
export * from "./OrderBonusSelectionForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__